import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const DealSizeRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/deal-sizes'),
});